import { Loading } from 'element-ui'

let authLoadingInstance = null

export function showWalletAuthLoading() {
	hideWalletAuthLoading()
	authLoadingInstance = Loading.service({
		lock: true,
		text: '',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.45)',
		customClass: 'wallet-auth-loading'
	})
	return authLoadingInstance
}

export function hideWalletAuthLoading() {
	if (authLoadingInstance) {
		authLoadingInstance.close()
		authLoadingInstance = null
	}
}
